import React from 'react';

class About extends React.Component {
    constructor(props) {
        super(props)
    }
      
    render() {
        return (
            <div>About </div>
        );
    }
}

export default About;